import React, { useState, useRef, useEffect } from "react";
import classes from './ChartLedger.module.css';
import { useReactToPrint } from "react-to-print";
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../Components/API/Api";
import {
    BarChart2,
    Filter,
    CalendarClock,
    Mail,
    ArrowLeft,
    Printer,
    Download,
    Settings
} from 'lucide-react';

const ChartLedger = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const componentRef = useRef(null);
    const token = localStorage.getItem("authToken");
    const [ledgerData, setLedgerData] = useState([]);
    const [loading, setLoading] = useState(true);
    const getTypeClass = (type) => {
        switch (type.toLowerCase()) {
            case "assets":
                return "asset";
            case "liabilities":
                return "liability";
            case "equity":
                return "equity";
            case "revenue":
                return "revenue";
            case "expenses":
                return "expense";
            default:
                return "";
        }
    };


    const typeMap = {
        "1": "Assets",
        "2": "Liabilities",
        "3": "Equity",
        "4": "Revenue",
        "5": "Expenses"
    };

    const categoryMap = {
        "1": "Current Assets",
        "2": "Non-current Assets",
        "3": "Current Liabilities",
        "4": "Non-current Liabilities",
        "5": "Equity",
        "6": "Operating Revenue",
        "7": "Cost of Sales",
        "8": "Operating Expenses"
    };


    const formatMoney = (value) => {
        const num = Number(value || 0);
        return num.toLocaleString("en-NG", { minimumFractionDigits: 2 });
    };

    useEffect(() => {
        const fetchAccounts = async () => {
            try {
                const response = await api.get(`/v1/account/company-accounts`);

                const accounts = Array.isArray(response.data.data?.data) ? response.data.data.data : [];
                const mappedData = accounts.map((account, index) => ({
                    id: account.id || `account-${index}`,
                    ref: account.gl_code || `REF-${index}`,
                    description: account.gl_name,
                    type: typeMap[account.class_id] || "Unknown",
                    category: categoryMap[account.category_id] || "Unknown",
                    balance: formatMoney(account.balance || 0),
                    status: account.status === "1" ? "Active" : "Inactive",
                }));


                setLedgerData(mappedData);
            } catch (error) {
                console.error("Error fetching chart of accounts:", error);
            } finally {
                setLoading(false);
            }
        };
        if (token) fetchAccounts();
        else setLoading(false);
    }, [token]);

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    const handleMail = () => alert("Mail clicked!");
    const handlePrinterd = () => window.print();

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
        copyStyles: true,
        pageStyle: `
        @page { margin: 12mm; size: auto; }
        html, body { height: auto !important; background: #ffffff !important; margin: 10mm; padding: 0; }
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        #invoice-print-root { display: block !important; visibility: visible !important; position: relative !important; width: 100% !important; background: #fff !important; color: #333 !important; padding: 12mm !important; }
        #invoice-print-root .table { min-width: auto !important; width: 100% !important; table-layout: fixed !important; }
        #invoice-print-root .table th, #invoice-print-root .table td { white-space: normal !important; word-break: break-word !important; }
        #invoice-print-root .tableContainer { overflow-x: visible !important; }
        #invoice-print-root * { visibility: visible !important; }
        #invoice-print-root > div:first-child { display: none !important; }
        `,
    });

    const handlePrinter = () => {
    try {
      const maybePromise = handlePrint && handlePrint();
      if (maybePromise && typeof maybePromise.then === "function") {
        maybePromise.catch(() => {
          window.print();
        });
      }
    } catch (err) {
      window.print();
    }
  };



    const handleDownload = () => {
        const csvContent = [
            ["Ref", "Description", "Type", "Category", "Balance", "Status"],
            ...ledgerData.map(d => [d.ref, d.description, d.type, d.category, d.balance, d.status])
        ].map(e => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "chart_of_accounts.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleSettings = () => navigate("/settings/chart-ledger");

    return (
        <div>
            <div className={`${classes.noPrint}`}>
                <HeaderNav activePage={pageMap[location.pathname]} />
            </div>

            <div className={classes.Container}>
                {/* Action Buttons */}
                <div className={classes.actions}>
                    <button className={classes.btns} onClick={() => navigate("/transactions/receivables/sales")}>
                        New Sales Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/inventory/purchaseOrder")}>
                        New Purchase Invoice
                    </button>
                    <button className={classes.btns} onClick={() => navigate("/customer-sales")}>
                        All Invoices
                    </button>
                    <button className={`${classes.btns} ${classes.greens}`} onClick={() => navigate("/settings/product-services")}>
                        Product & Services
                    </button>
                </div>
                <div className={classes.act}>
                    <form className={classes.form}>
                        <div className={classes.group}>
                            <label>Period:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>Current month</option>
                                    <option>Last month</option>
                                    <option>This year</option>
                                    <option>Custom range</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>
                        <div className={classes.group1}>
                            <label>Group by:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>None</option> <option>Date</option>
                                    <option>Transaction Type</option>
                                    <option>Amount</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div> </div> <div className={classes.group1}>
                            <label>Start Date:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>01/01/25</option> <option>01/12/24</option>
                                    <option>01/11/24</option> <option>01/10/24</option>
                                </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>
                        <div className={classes.group1}>
                            <label>End Date:</label>
                            <div className={classes.dropdownWrapper}>
                                <select className={classes.statusDropdown}>
                                    <option>{new Date().toLocaleDateString('en-GB')}</option>
                                    <option>31/12/24</option> <option>30/11/24</option>
                                    <option>31/10/24</option> </select>
                                <span className={classes.arrowDown}>▼</span>
                            </div>
                        </div>
                        <div className={classes.group1}>
                            <button className={classes.greenBtn}
                                type="button"> <BarChart2 size={16} style={{ marginRight: "6px" }}
                                />
                                Run Report
                            </button>
                        </div>
                    </form>
                    <div className={classes.iconbarr}>
                        <div className={classes.iconbar}>
                            <Filter size={16} style={{ marginRight: "6px" }}
                            />
                            Filter
                        </div>
                        <div className={classes.iconbar}>
                            <CalendarClock size={16} style={{ marginRight: "6px" }} />
                            Schedule
                        </div>
                    </div>
                </div>
                <div className={classes.matron}> <div>
                    <button className={classes.backButton}
                        onClick={() => navigate(-1)}> <ArrowLeft size={16} style={{ marginRight: '6px' }}
                        />
                    </button>
                </div>
                    <div>
                        <p className={classes.toplea}>Charts of Accounts Ledger</p>
                        <p className={classes.topl}>Financial position as of {new Date().toLocaleDateString()}</p>
                    </div>
                </div>

                {/* Table */}
                <div 
                    id="invoice-print-root"
                    className={`${classes.containere} ${classes.printable}`}
                    ref={componentRef}
                        // className={classes.containere}
                
                >
                    <div className={classes.iconbars}>
                        <div className={classes.iconbarss}>
                            <div className={classes.iconbar} onClick={handleMail} style={{ cursor: "pointer" }}>
                                <Mail size={16} />
                            </div>
                            {/* <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}> */}
                            <div className={classes.iconbar} onClick={handlePrinter} style={{ cursor: "pointer" }}>
                                <Printer size={16} />
                            </div>
                            <div className={classes.iconbar} onClick={handleDownload} style={{ cursor: "pointer" }}>
                                <Download size={16} />
                            </div>
                            <div className={classes.iconbar} onClick={handleSettings} style={{ cursor: "pointer" }}>
                                <Settings size={16} />
                            </div>

                        </div>
                    </div>
                    <div className={classes["invoice-box"]}>
                        <header className={classes.headers}>
                            <h1 className={classes.companyName}>Promix Accounting Ltd</h1>
                            <h2 className={classes.title}>CHARTS OF ACCOUNTS LEDGER</h2>
                            <p className={classes.period}>For the period ended {new Date().toLocaleDateString()}</p>
                            <button className={classes.unaudited}>unaudited</button>
                        </header>

                        <div className={classes.divider}></div>

                        <div className={classes.tableContainer}>
                            <table className={classes.table}>
                                <thead>
                                    <tr className={classes.tableHeader}>
                                        <th>Account Code</th>
                                        <th>Account Name</th>
                                        <th>Type</th>
                                        <th style={{ textAlign: "left" }}>Category</th>
                                        <th>Balance</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="6" style={{ textAlign: 'center' }}>Loading...</td>
                                        </tr>
                                    ) : ledgerData.length > 0 ? (
                                        ledgerData.map((row) => (
                                            <tr key={row.id} className={classes.tableRow}>
                                                <td>{row.ref}</td>
                                                <td>{row.description}</td>
                                                <td>
                                                    <span className={`${classes.typeBadge} ${classes[getTypeClass(row.type)]}`}>
                                                        {row.type}
                                                    </span>
                                                </td>

                                                <td style={{ textAlign: "left" }}>{row.category}</td>
                                                <td style={{ textAlign: 'right' }}>{row.balance}</td>
                                                <td style={{ color: row.status === "Active" ? "green" : "red", fontWeight: "600" }}>
                                                    {row.status}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                                No chart ledger entries found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>                    

                </div>
            </div>
            <Footer />
        </div>
    );
};

export default ChartLedger;
